<template>
  <div class="col">
    <div class="row">
      <h2>Connexion</h2>
    </div>
    <div class="row">
      <div class="col form">
        <div class="row">
          <label for="email">Email</label>
        </div>
        <div class="row">
          <input
            id="email"
            v-model="email"
            class="field"
            type="text"
            name="email"
            @keypress.enter="submit"
          >
        </div>
        <div class="row">
          <label for="password">Mot de passe</label>
        </div>
        <div class="row">
          <input
            id="password"
            v-model="password"
            class="field"
            type="password"
            name="password"
            @keypress.enter="submit"
          >
        </div>
        <div
          v-if="hasError"
          class="row"
        >
          <ErrorMessage>La combinaison mail / mot de passe ne correspond pas.</ErrorMessage>
        </div>
        <div class="row submit">
          <CustomButton
            :class="authSuccess ? 'green':''"
            :loading="isPending"
            :disabled="!isValidForm()"
            @click.native="submit()"
          >
            <span
              v-if="authSuccess"
              class="fas fa-check"
            ></span>
            {{ authSuccess ? 'Connecté' : 'Connexion' }}
          </CustomButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FirebaseAuth from '../tools/FirebaseAuth';
  import ErrorMessage from './micro-components/error-message';
  import CustomButton from './micro-components/custom-button';
  import store from './../stores';

  export default {
    name: 'Authentication',
    components: {
      ErrorMessage,
      CustomButton,
    },
    data() {
      return {
        email: null,
        password: null,
        authSuccess: false
      };
    },
    computed: {
      isPending() {
        return store.state.auth.isPending;
      },
      hasError() {
        return store.state.auth.hasError;
      }
    },
    methods: {
      async submit() {
        if (this.isValidForm() && !this.authSuccess) {
          try {
            await FirebaseAuth.authenticate(this.email, this.password);
            this.authSuccess = true;
            this.$router.push({ name: 'home' });
            // eslint-disable-next-line
          } catch (e) {
          }
        }
      },
      isValidForm() {
        return this.email && this.password;
      }
    }
  };
</script>

<style scoped>
    .row {
        justify-content: center;
    }

    .col.form {
        width: 100%;
        max-width: 450px;
    }

    .field {
        margin-bottom: 0.5em;
    }

    label {
        font-size: 1.2em;
    }

    .submit {
        margin-top: 1em;
    }

    h3, h2 {
        margin: 0;
    }

    .field {
        line-height: 2em;
    }
</style>
